import { Component, OnInit, Input, AfterViewChecked, ViewChild, Output, EventEmitter, HostListener } from '@angular/core';
import { CdkDrag, CdkDragStart, CdkDropList, CdkDropListGroup, CdkDragMove, CdkDragEnter, moveItemInArray } from '@angular/cdk/drag-drop';
import { MediaGalleryAddImageDialogComponent } from 'src/app/components/shared-components/media-gallery/media-gallery-add-image-dialog/media-gallery-add-image-dialog.component';
import { MediaGalleryAddVideoDialogComponent } from 'src/app/components/shared-components/media-gallery/media-gallery-add-video-dialog/media-gallery-add-video-dialog.component';
import { ViewportRuler } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { MediaGalleryZoomDialogComponent } from './media-gallery-zoom-dialog/media-gallery-zoom-dialog.component';
import { MediaGalleryItem } from './media-gallery-item/media-gallery-item.model';
import { MediaGalleryAddHtmlDialogComponent } from 'src/app/components/shared-components/media-gallery/media-gallery-add-html-dialog/media-gallery-add-html-dialog.component';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { MediaGalleryEditDialogComponent } from 'src/app/components/shared-components/media-gallery/media-gallery-edit-dialog/media-gallery-edit-dialog.component';
import { MediaGalleryDeleteDialogComponent } from 'src/app/components/shared-components/media-gallery/media-gallery-delete-dialog/media-gallery-delete-dialog.component';

@Component({
  selector: 'app-media-gallery',
  templateUrl: './media-gallery.component.html',
  styleUrls: ['./media-gallery.component.scss']
})
export class MediaGalleryComponent implements OnInit, AfterViewChecked {

  @ViewChild(CdkDropListGroup, { static: false }) listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList, { static: false }) placeholder: CdkDropList;
  @Output() outputEvent = new EventEmitter<any>();
  @Output() addOutputEvent = new EventEmitter<any>();
  @Input() items: Array<MediaGalleryItem>;
  public selectedItems: Array<MediaGalleryItem>;
  public target: CdkDropList;
  public targetIndex: number;
  public source: CdkDropList;
  public sourceIndex: number;
  public dragIndex: number;
  public activeContainer;
  private viewChecked = false;
  public itemsPerRow = 6;

  constructor(private viewportRuler: ViewportRuler,
              private dialog: MatDialog) {
                this.target = null;
                this.source = null;
  }

  ngOnInit() {
    this.onResize();
  }

  public updateItem(data) {
    this.items[this.items.indexOf(data['currentItem'])] = data['item'];
    this.outputEvent.emit(this.items);
  }

  public removeItem(item) {
    this.items.splice(this.items.indexOf(item), 1);
    this.outputEvent.emit(this.items);
  }

  public editSelectedItems() {
    const dialogRef = this.dialog.open(MediaGalleryEditDialogComponent, {
      data: this.filterItemsPerType() });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.items.filter(
          (i) => {
            return i.Selected === true;
          }
        ).forEach(
          (e) => {
            if ((e.Type === 'IMAGE_FILE') || (e.Type === 'IMAGE_URL')) {
              e.Duration = result.imagesDuration;
            }
            if ((e.Type === 'VIDEO_FILE') || (e.Type === 'VIDEO_URL') || (e.Type === 'VIDEO_YOUTUBE')) {
              e.Cycles = result.videosCycles;
            }
            if ((e.Type === 'WEB_SCRIPT') || (e.Type === 'WEB_URL')) {
              e.Duration = result.htmlsDuration;
              e.ZoomLevel = result.htmlsZoomLevel;
            }
          }
        );
        this.updateSelectedItems();
        this.outputEvent.emit(this.items);
      }
    });
  }

  public deleteSelectedItems() {
    const dialogRef = this.dialog.open(MediaGalleryDeleteDialogComponent, {
      data: this.filterItemsPerType()
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.items.filter(
          (i) => {
            return i.Selected === true;
          }
        ).forEach(
          (e) => {
            this.items.splice(this.items.indexOf(e), 1);
          }
        );
        this.updateSelectedItems();
        this.outputEvent.emit(this.items);
      }
    });
  }

  public filterItemsPerType() {
    const selectedImages = new Array<any>();
    const selectedVideos = new Array<any>();
    const selectedHtmls = new Array<any>();
    this.selectedItems.forEach(
      (i) => {
        if ((i.Type === 'IMAGE_FILE') || (i.Type === 'IMAGE_URL')) {
          selectedImages.push(i);
        }
        if ((i.Type === 'VIDEO_FILE') || (i.Type === 'VIDEO_URL') || (i.Type === 'VIDEO_YOUTUBE')) {
          selectedVideos.push(i);
        }
        if ((i.Type === 'WEB_SCRIPT') || (i.Type === 'WEB_URL')) {
          selectedHtmls.push(i);
        }
      }
    );
    return { selectedImages, selectedVideos, selectedHtmls };
  }

  public updateSelectedItems() {
    this.selectedItems = new Array<MediaGalleryItem>();
    if (this.items && this.selectedItems) {
      this.items.forEach(
        (i) => {
          if (i.Selected) {
            this.selectedItems.push(i);
          }
        }
      );
    }
  }

  public selectAll() {
    this.items.forEach(
      (i) => {
        i.Selected = true;
      }
    );
    this.updateSelectedItems();
  }

  public unselectAll() {
    this.items.forEach(
      (i) => {
        i.Selected = false;
      }
    );
    this.updateSelectedItems();
  }

  @HostListener('window:resize', ['event'])
  onResize() {
    if ((window.innerWidth <= 552)) {
      this.itemsPerRow = 2;
    } else if ((window.innerWidth > 552) && (window.innerWidth <= 768)) {
      this.itemsPerRow = 3;
    } else if ((window.innerWidth > 768) && (window.innerWidth <= 1200)) {
      this.itemsPerRow = 4;
    } else if ((window.innerWidth > 1200) && (window.innerWidth <= 1600)) {
      this.itemsPerRow = 6;
    } else if (window.innerWidth > 1600) {
      this.itemsPerRow = 8;
    }
  }

  // ******************************************************************************************************************* //
  // **************************************************  DRAG & DROP  ************************************************** //
  // ******************************************************************************************************************* //

  ngAfterViewChecked() {
    if (this.items && !this.viewChecked && this.placeholder) {
      const phElement = this.placeholder.element.nativeElement;
      phElement.style.display = 'none';
      phElement.parentElement.removeChild(phElement);
      this.viewChecked = true;
    }
  }

  public dragMoved(e: CdkDragMove) {
    const point = this.getPointerPositionOnPage(e.event);

    this.listGroup._items.forEach(dropList => {
      if (__isInsideDropListClientRect(dropList, point.x, point.y)) {
        this.activeContainer = dropList;
        return;
      }
    });
  }

  public dropListDropped() {
    if (!this.target) {
      return;
    }
    const phElement = this.placeholder.element.nativeElement;
    const parent = phElement.parentElement;
    phElement.style.display = 'none';
    parent.removeChild(phElement);
    parent.appendChild(phElement);
    parent.insertBefore(this.source.element.nativeElement, parent.children[this.sourceIndex]);
    this.target = null;
    this.source = null;
    if (this.sourceIndex !== this.targetIndex) {
      moveItemInArray(this.items, this.sourceIndex, this.targetIndex);
      this.outputEvent.emit(this.items);
    }
  }

  public dropListEnterPredicate = (drag: CdkDrag, drop: CdkDropList) => {
    if (drop === this.placeholder) {
      return true;
    }
    if (drop !== this.activeContainer) {
      return false;
    }
    const phElement = this.placeholder.element.nativeElement;
    const sourceElement = drag.dropContainer.element.nativeElement;
    const dropElement = drop.element.nativeElement;
    const dragIndex = __indexOf(dropElement.parentElement.children, (this.source ? phElement : sourceElement));
    const dropIndex = __indexOf(dropElement.parentElement.children, dropElement);
    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = drag.dropContainer;
      phElement.style.width = sourceElement.clientWidth + 'px';
      phElement.style.height = sourceElement.clientHeight + 'px';
      sourceElement.parentElement.removeChild(sourceElement);
    }
    this.targetIndex = dropIndex;
    this.target = drop;
    phElement.style.display = '';
    dropElement.parentElement.insertBefore(phElement, (dropIndex > dragIndex ? dropElement.nextSibling : dropElement));
    this.placeholder.enter(drag, drag.element.nativeElement.offsetLeft, drag.element.nativeElement.offsetTop);
    return false;
  }

  public getPointerPositionOnPage(event: MouseEvent | TouchEvent) {
    const point = __isTouchEvent(event) ? (event.touches[0] || event.changedTouches[0]) : event;
    const scrollPosition = this.viewportRuler.getViewportScrollPosition();
    return {
      x: point.pageX - scrollPosition.left,
      y: point.pageY - scrollPosition.top
    };
  }
  // ******************************************************************************************************************* //
  // ******************************************************************************************************************* //
  // ******************************************************************************************************************* //
}

function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
}

function __isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
  return event.type.startsWith('touch');
}

function __isInsideDropListClientRect(dropList: CdkDropList, x: number, y: number) {
  const { top, bottom, left, right } = dropList.element.nativeElement.getBoundingClientRect();
  return y >= top && y <= bottom && x >= left && x <= right;
}

